import React from "react";
import { Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { DIALOG_ANIMATIONS } from "../utils/constants";

const SlideTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return (
    <Slide
      direction="up"
      ref={ref}
      {...props}
      timeout={{
        enter: DIALOG_ANIMATIONS.ENTER_DURATION,
        exit: DIALOG_ANIMATIONS.EXIT_DURATION
      }}
    />
  );
});

export default SlideTransition;
